/**
 * Created by Alex Aguilar on 9/6/2016.
 */
(function () {
    'use strict';

    var remoteValidateUnique = {
        templateUrl: 'app/components/validate/remoteValidateUnique.html',
        controller: remoteValidateUniqueController,
        controllerAs: 'vm',
        require: {
            model: "ngModel"
        },
        bindings: {
            id: '@',
            errorKey: '@',
            formName: '<',
            formValue: '=',
            onSuccessValidate: '&'
        }
    }

    angular
        .module('completeAir')
        .component('remoteValidateUnique', remoteValidateUnique)

    remoteValidateUniqueController.$inject = ['$element', '$timeout', 'countryService', 'regionService', 'airCrewService',
        'complementAirCrewService', 'tariffClassService', 'userService', 'makerService', 'branchOfficeService',
        'structureSeatMapService', 'itineraryService', 'cityService', 'airportService', 'modelAircraftService', 'fareService', 'offerService', '$q'];

    function remoteValidateUniqueController($element, $timeout, countryService, regionService, airCrewService,
                                            complementAirCrewService, tariffClassService, userService, makerService,
                                            branchOfficeService, structureSeatMapService, itineraryService, cityService,
                                            airportService, modelAircraftService, fareService, offerService, $q) {
        var vm = this;
        vm.value = "";
        vm.isLoad = false;
        vm.isFormNew = null;
        vm.valueCurrent = "";

        vm.$onInit = function () {
            var input = $element.parent(),
                inputJQ = input.find('.form-control');

            vm.valueCurrent = vm.formValue;

            inputJQ.on("keydown change", function () {
                $timeout(function () {
                    vm.value = vm.model.$viewValue;
                    var dataService = null;

                    if (vm.value !== undefined && vm.value !== "") {
                        if(vm.valueCurrent === '' || vm.valueCurrent === undefined) {
                            dataService = vm.onDataService(vm.value);
                        } else if ((vm.valueCurrent !== '' || vm.valueCurrent !== undefined) && vm.valueCurrent !== vm.value) {
                            dataService = vm.onDataService(vm.value);
                        } else if ((vm.valueCurrent !== '' || vm.valueCurrent !== undefined) && vm.valueCurrent === vm.value){
                            dataService = null;
                        }

                        if (dataService != null) {
                            dataService.then(function (response) {
                                if (response.data === true) {
                                    vm.formName.$setValidity(vm.errorKey, false);
                                } else {
                                    vm.formName.$setValidity(vm.errorKey, true);
                                }
                                vm.isLoad = false;
                            });
                        }else {
                            vm.formName.$setValidity(vm.errorKey, true);
                            vm.isLoad = false;
                        }
                    }
                });
            });
        };

        vm.onDataService = function () {
            var dataService = null;

            switch (vm.errorKey) {
                case "uniqueCountryName":
                    dataService = countryService.thereNameCountry(vm.value);
                    break;
                case "uniqueCountryIata":
                    dataService = countryService.thereIataCountry(vm.value);
                    break;
                case "uniqueRegionName":
                    if(vm.id !== undefined && vm.id !== "") {
                        dataService = regionService.thereRegionNameByCountry(vm.value, vm.id);
                    }
                    break;
                case "uniqueCityName":
                    if(vm.id !== undefined && vm.id !== "") {
                        dataService = cityService.thereCityNameByRegion(vm.value, vm.id);
                    }
                    break;
                case "uniqueAirportName":
                    dataService = airportService.thereAirportName(vm.value);
                    break;
                case "uniqueAirportIataCode":
                    dataService = airportService.thereAirportIataCode(vm.value);
                    break;
                case "uniqueNroIdentity":
                    dataService = airCrewService.thereIdentityNumber(vm.value);
                    break;
                case "uniqueLicence":
                    dataService = airCrewService.thereLicense(vm.value);
                    break;
                case "uniqueFareClassName":
                    dataService = tariffClassService.thereFareClassName(vm.value);
                    break;
                case "uniqueFareClassIataCode":
                    dataService = tariffClassService.thereFareClassIataCode(vm.value);
                    break;
                case "uniqueUserEmail":
                    if(validateEmail(vm.value)) {
                        dataService = userService.thereEmail(vm.value);
                    }
                    break;
                case "uniqueMakerName":
                    dataService = makerService.thereNameMaker(vm.value);
                    break;
                case "uniqueBranchName":
                    dataService = branchOfficeService.thereNameBranch(vm.value);
                    break;
                case "uniqueStructureName":
                    dataService = structureSeatMapService.thereNameStructure(vm.value);
                    break;
                case "uniqueItineraryName":
                    dataService = itineraryService.thereNameItinerary(vm.value);
                    break;
                case "uniqueModelAircraftIata":
                    dataService = modelAircraftService.thereIataModelAircraft(vm.value);
                    break;
                case "uniqueFareName":
                    dataService = fareService.thereFareName(vm.value);
                    break;
                case "uniqueDestination":
                    if(vm.formValue.destination.id == 0){
                        $q.resolve({ data: false });
                    }
                    else {
                        dataService = offerService.thereOffer(vm.formValue.origin.id, vm.formValue.destination.id);
                    }
                    break;
            }
            return dataService;
        }
    }

    function validateEmail(email) {
        var re = /^(([a-zA-Z0-9_.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+([;,.](([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+)*$/;
        return re.test(email);
    }
})();

